<template>
  <BurgerMenuBtn
    @click="toggleBtnClickAnimation"
    class="z-9999 drop-shadow-lg scale-0"
    id="burger"
  />

  <div
    @click="toggleBtnClickAnimation"
    class="z-9998 fixed inset-0 bg-black opacity-50 size-full select-none"
    :class="{ hidden: !isNavbarOpen }"
  ></div>

  <div
    tabindex="0"
    id="navbar"
    @keydown.esc="toggleBtnClickAnimation()"
    class="top-[1dvh] right-0 z-9998 fixed bg-flax-smoke-950 p-5 sm:p-10 md:px-20 rounded-s-lg focus:outline-hidden w-full max-md:w-[98%] md:w-3/5 lg:w-2/5 h-[98dvh] translate-x-full select-none will-change-auto"
  >
    <Circles id="circles" class="top-0 right-0 absolute opacity-25" />
    <div class="flex flex-col justify-between items-center h-full">
      <div class="z-19 relative w-full">
        <ul
          class="mt-12 md:mt-24 font-bold text-flax-smoke-50 heading-2"
          id="navLinks"
        >
          <li
            class="overflow-y-clip"
            v-for="l in navbarLinks"
            :key="l.label"
            :id="l.label"
          >
            <a
              :href="l.url"
              @click="gotoSection(l.url)"
              class="group flex justify-start items-center my-2 w-fit h-full leading-none translate-y-full cursor-pointer will-change-auto"
            >
              <span
                class="bg-flax-smoke-50 opacity-0 group-hover:opacity-100 rounded-full w-4 h-4 scale-0 group-hover:scale-100 transition-all duration-300 ease-in-out"
              ></span>
              <p
                class="font-fancy transition-all -translate-x-5 group-hover:translate-x-5 duration-300 ease-in-out"
              >
                {{ l.label }}
              </p>
            </a>
          </li>
        </ul>
      </div>

      <div class="w-full">
        <div class="mt-2 h-full font-normal text-flax-smoke-50">
          <p class="font-bold text-sm text-left uppercase">Email address</p>
          <Link
            class="h-6! font-medium tracking-wider"
            tag="p"
            label="contact@jslorenzo.dev"
            url="mailto:contact@jslorenzo.dev"
          />
          <div class="flex flex-wrap justify-start gap-1 mt-6">
            <Button
              class="opacity-0 border border-flax-smoke-600 contact"
              v-for="social in socialLinks"
              :key="social.label"
              :label="social.label"
              :url="social.url"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <header
    :class="$attrs.class"
    class="z-20 absolute inset-0 pt-6 h-fit -translate-y-full will-change-auto padding-x"
  >
    <nav class="flex justify-between">
      <MagneticEffect
        :magnetoStrengthVal="20"
        :magnetoTextStrengthVal="10"
        divId="name-container"
        textId="name"
      >
        <div id="name-container" class="group -m-10 p-10 h-fit cursor-pointer">
          <h2
            id="name"
            class="flex items-start font-fancy font-extrabold text-xl md:text-3xl uppercase"
          >
            <img :src="jslorenzoLogo" class="fill-[#000] h-[60px]" alt="John Savar Lorenzo full-stack developer">
           
            
          </h2>
        </div>
      </MagneticEffect>

      <div class="flex justify-start">
        <p
          class="hidden md:block font-fancy font-bold text-flax-smoke-400 uppercase select-none heading-6"
        >
      Looking for a web developer <br />who treats your project <br />like their own? Let’s talk.
        </p>
      </div>
      <div class="flex">
        <ul
          class="md:flex flex-1 gap-1 md:gap-2 lg:gap-4 w-full overflow-y-hidden font-medium text-lg md:text-xl lg:text-2xl xl:text-3xl"
        >
          <Link
            v-for="(l, index) in navLinks"
            :key="l.label"
            tag="li"
            :label="l.label + (index !== navLinks.length - 1 ? '' : '')"
            :url="l.url"
          />
        </ul>
      </div>
    </nav>
  </header>
</template>
<script setup lang="ts">
  import { onMounted, ref, watch } from 'vue';
  import jslorenzoLogo from  '../../assets/images/jslorenzoLogo.svg'
  import { Link, BurgerMenuBtn, MagneticEffect } from '..';
  import { Circles } from '../design';
  import { Button } from '../common';

  import {
    animateNavbarEnter,
    animateNavbarLeave,
    navbarScale,
  } from '@/animations';
  import { navbarLinks, navLinks, socialLinks } from '@/data';
  import { lenis } from '@/main';

  const isNavbarOpen = ref(false);

  const toggleBtnClickAnimation = () => {
    isNavbarOpen.value = !isNavbarOpen.value;

    // animate the X on the button
    document.getElementById('magneto')?.classList.toggle('active');

    const x = document.getElementById('navbar') as HTMLDivElement;
    if (isNavbarOpen.value) {
      animateNavbarEnter('#navbar', '#navLinks li a', '.contact');
      x.focus();
    } else {
      animateNavbarLeave('#navbar', '#navLinks li a', '.contact');
      x.blur();
    }
  };

  const gotoSection = (url: string) => {
    lenis.start();
    lenis.scrollTo(url, { duration: 3 });
    toggleBtnClickAnimation();
  };

  onMounted(() => {
    navbarScale('#burger', '#hero');
  });

  const emit = defineEmits(['isLocked']);
  watch(isNavbarOpen, (newVal) => {
    emit('isLocked', newVal);
  });
</script>
